import React from 'react';
import { Link } from 'react-router-dom';

import classes from './NavigationLink.module.css';

import { IsStringEmpty } from '../../../../utilities/CommonMethods';

const navigationLinks = (props) => {
    let styleClasses = [classes.NavigationLink];
    if (!IsStringEmpty(props.styleclass)) {
        const styles = props.styleclass.split(' ');
        for (let style in styles) {
            styleClasses.push(classes[styles[style].trim()]);
        }
    }

    props.topbarTheme === 'Dark' ? styleClasses.push(classes.Dark) : styleClasses.push(classes.Light);

    const stopBlink = window.location.pathname.indexOf('/course/') === 0 ? true : false;

    const icon = !props.icon ? null : <span className={classes.LinkIcon}>{props.icon}</span>;

    return (

        props.showDropdown || props.clickable
            ?
            <div className={styleClasses.join(' ')} onClick={props.megaMenuDropdownClick}>
                <div className={props.active ? classes.active : null}>
                    <div className={classes.HorizontalAlign}>
                        {
                            props.label !== 'Programs'
                                ? props.label
                                : <p className={classes.ProgramsText}>Pr
                                    <svg className={classes.FrameSVG} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 216 194">
                                        <polyline className={[classes.FrameSVGLine, props.topbarTheme === 'Dark' ? classes.DarkTheme : null].join(' ')} points="57.36 5.82 5.96 5.82 5.96 57.9" />
                                        <polyline className={[classes.FrameSVGLine, props.topbarTheme === 'Dark' ? classes.DarkTheme : null].join(' ')} points="5.96 136.2 5.96 187.27 57.36 187.27" />
                                        <polyline className={[classes.FrameSVGLine, props.topbarTheme === 'Dark' ? classes.DarkTheme : null].join(' ')} points="157.79 187.27 209.87 187.27 209.87 136.2" />
                                        <polyline className={[classes.FrameSVGLine, props.topbarTheme === 'Dark' ? classes.DarkTheme : null].join(' ')} points="157.79 5.82 209.87 5.82 209.87 57.9" />
                                    </svg>
                                    <span className={stopBlink ? null : classes.Blink}></span>grams</p>
                        }
                    </div>
                </div>
            </div>
            :
            <div className={styleClasses.join(' ')}>
                {
                    props.isExternal ?
                        <a target="_blank" rel="noopener noreferrer" href={props.link}>{icon}{props.label}{
                            !props.showNewLabel ? null :
                                <span className={classes.NewLabel}>New</span>
                        }</a> :
                        <Link to={props.link} className={props.active ? classes.active : null}>
                            {icon}
                            {props.label}
                            {
                                !props.showNewLabel ? null :
                                    <span className={classes.NewLabel}>New</span>
                            }
                        </Link>
                }
            </div>
    )
}

export default navigationLinks;